export default __webpack_public_path__ + "assets/logo1.b12eea3e.png";